import {
  defaultOperatorFor,
  type FieldDefinition,
  type FilterCondition,
} from "@estelle/domain";

/**
 * A new clause on a known field, with that field type's default operator
 * (`defaultOperatorFor` — "is any of" for an enum, the first on offer for the
 * rest).
 *
 * The filter bar's field dropdown already knows which field was chosen —
 * unlike the builder's "+ Condition", which has to guess one — so it calls
 * this instead of picking a default and immediately reassigning it.
 */
export function newConditionFor(field: FieldDefinition): FilterCondition {
  return {
    kind: "condition",
    field: field.name,
    operator: defaultOperatorFor(field.type),
  };
}

/**
 * A new clause on the first filterable field, with that type's default
 * operator.
 *
 * Prefilled rather than blank: an empty row asks the user to make three
 * choices before seeing anything happen, and the first field with its most
 * common operator is right often enough to be worth changing rather than
 * starting from nothing.
 */
export function newCondition(fields: FieldDefinition[]): FilterCondition {
  const field = fields.find((f) => f.filterable !== false);
  return field
    ? newConditionFor(field)
    : { kind: "condition", field: "", operator: "is" };
}
